export const chartTabClassName =
  'h-auto rounded-none bg-transparent p-0 text-sm font-normal text-muted-foreground hover:bg-transparent hover:text-foreground'

export const chartTabActiveClassName = 'text-foreground hover:text-foreground'
